import React from 'react';

import Welcome from '../components/marketing/Welcome';
import ProjectSection from '../components/project/ProjectSection';

import GreetUser from '../components/user/GreetUser';

import {
    RESOLVE_LOCAL_AUTH_STATE,
    RESOLVE_LOCAL_USER_STATE
  } from "../components/auth/AuthActions";

class RootPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auth: RESOLVE_LOCAL_AUTH_STATE(),
            user: RESOLVE_LOCAL_USER_STATE()
        };
    }
    componentDidMount() {
        this.setState({
            loading: false
        });
    }
    render() {
        const is_authenticated = this.state.auth.is_authenticated === "true" ? true : false;
        return (
            <div>
                {!is_authenticated && (
                    <Welcome />
                )}
                {is_authenticated && (
                    <GreetUser />
                )}
                <ProjectSection
                    title="Recent Projects"
                    subtitle="By the inertia7 community:"
                    limit={6}
                />
                <ProjectSection
                    title="Most Viewed"
                    ordering="-view_count"
                    limit={6}
                />
                <ProjectSection
                    title="Discover"
                    limit={6}
                    shuffle={true}
                />
            </div>
        )
    }
}

export default RootPage;